import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { MdAccessTime } from "react-icons/md";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FiLock } from "react-icons/fi";
import { MdOutlineStarPurple500 } from "react-icons/md";
import { LuGlobe } from "react-icons/lu";
import Modal from "react-modal";
import { trackTikTokEvent } from "../utils/tiktok";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  height: 100vh;
  background: url("/assets/NewMiniapp/doctorBG.jpg");
  background-size: contain;
    background-position: top left;
    background-repeat: no-repeat !important;

  /* Mobile */
  @media (max-width: 768px) {
  justify-content: center;
    align-items: end;
    background: url("/assets/NewMiniapp/main-doctor5.png") no-repeat center center;
    background-size: cover;
    padding: 0px;
  }
`;

const Card = styled.div`
  width: 96%;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.9);
  // border-radius: 20px;
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.15);
  padding: 30px;
  text-align: center;
  position: relative;
  overflow-y:auto
`;

const Header = styled.h4`
  margin-bottom: 5x;
  color: #333;
  font-weight:bold
`;

const FormField = styled.div`
  margin-bottom: 5x;
  text-align: left;
`;

const Label = styled.label`
  display: block;
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  padding-top: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 10px;
  outline: none;
  transition: border 0.3s ease;
  background-color: rgb(187, 7, 0, 0.1);
  &:focus {
    border-color: #BB0700 !important;
  }
`;

const ErrorText = styled.div`
  color: red;
  font-size: 14px;
`;

const SubmitButton = styled.button`
  background: #BB0700;
  margin-top: 15px;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px;
  font-size: 13px;
  width:100%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: background 0.3s ease, transform 0.3s ease;
  &:hover {
    background: ${(props) =>
    props.disabled ? "#BB0700" : "#0056b3"};
    transform: ${(props) => (props.disabled ? "none" : "scale(1.01)")};
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 5x;
  min-width:80px
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: end;
  cursor: pointer;
  padding: 2px;
  background: rgb(187, 7, 0,0.1);
  border-radius: 10px;
  border: 1px solid rgb(187, 7, 0,0.3);
  font-size: 13px;
  color: #BB0700;
  font-weight: bold;
  > svg {
    margin-right: 10px;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

const DropdownItem = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
`;

const DisclaimerModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  padding: 20px;
  width: 80%;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 325px;
`;

const ModalHeader = styled.h2`
  margin-bottom: 5x;
  color: #333;
`;

const ModalBody = styled.div`
  font-size: 16px;
  color: #333;
  margin-bottom: 5x;
`;

const VerifyingText = styled.div`
  font-size: 16px;
  color: #333;
  margin-top: 20px;
`;

const SignUpForm = () => {

  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  const trackEvent = (action, category, label) => {
    if (window.gtag) {
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
      });
      // Log to console for debugging
      console.log(
        `Event tracked: ${action}, Category: ${category}, Label: ${label}`
      );
    } else {
      // Log a message if gtag is not defined
      console.log("gtag is not defined, event not tracked:", {
        action,
        category,
        label,
      });
    }
  };

  useEffect(() => {
    trackEvent("page_load", "user_interaction", "signup_page");
  }, []);

  useEffect(() => {
    // const lang = i18n.language;
    const lang = i18n.language || "en";

    document.body.classList.remove("lang-en", "lang-ps", "lang-fa");
    document.body.classList.add(`lang-${lang}`);
  }, [i18n.language]);

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    setDropdownOpen(false);
  };

  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("93");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleMobileNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) return;

    setMobileNumber(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!name) newErrors.name = t("nameError");
    if (!mobileNumber || mobileNumber.length !== 11) {
      newErrors.mobileNumber = t("mobileNumberError");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Proceed with verification if there are no errors
    handleVerification();
  };


  const handleVerification = async () => {
    trackEvent("button_click", "user_interaction", "Login-btn");

    setIsVerifying(true);
    try {
      const response = await authenticateUser(mobileNumber, name);
      if (response.data.patientProfile.isFeaturePackageActivated) {
        navigate("/dashboard");
      } else {
        trackTikTokEvent("ButtonClick", {
          event_category: "user_interaction",
          event_label: "Next-btn",
        });
        navigate("/feature-package");
      }
    } catch (error) {
      console.error("Error during authentication:", error);
    } finally {
      setIsVerifying(false);
    }
  };

  const authenticateUser = async (userMsisdn, userPName) => {
    try {
      const response = await axios.post(
        "https://bundleapi.webddocsystems.com/api/Account/Register",
        {
          mobileNumber: userMsisdn,
          customerName: userPName,
          gender: "male",
        }
      );

      const user = {
        userMsisdn: response.data.patientProfile.mobileNumber,
        userName: response.data.patientProfile.name,
        applicationUserId: response.data.patientProfile.id,
        userEmail: `${response.data.patientProfile.mobileNumber}@webdoc.com.pk`,
        package: response.data.patientProfile.isPackageActivated,
        featuresPackage: response.data.patientProfile.isFeaturePackageActivated,
        headOfGreeting: response.data.patientProfile.headOfGreeting,
        contentOfGreeting: response.data.patientProfile.contentOfGreeting,
        appointmentId: response.data.patientProfile.appointmentid,
        featurePackageDetails:
          response.data.patientProfile.featurePackageDetails,
        message: "User registered and authenticated successfully.",
      };
      sessionStorage.setItem("userData", JSON.stringify(user));
      return response;
    } catch (error) {
      console.error("Error registering user:", error);
      throw error;
    }
  };

  return (
    <Container className="px-0">
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: `
      linear-gradient(
        to right,
        rgba(180, 10, 30, 0.18) 0%,
        rgba(180, 10, 30, 0) 60%
      ),
      linear-gradient(
        to top,
        rgba(160, 14, 38, 0.88) 0%,
        rgba(160, 14, 38, 0.04) 55%
      )
    `,
        }}
      >
      </div>
      <div className="p-3 ps-5 noDisplayOnPhone" style={{ zIndex: "1" }}>
        <div className="p-2 mb-4 d-flex align-items-center gap-2 rounded-pill text-white" style={{ border: "1px solid #FFFFFF", backgroundColor: "rgb(255, 255, 255,0.2)", fontSize: "14px", width: "fit-content" }}>
          <div className="rounded-circle" style={{ height: "8px", width: "8px", backgroundColor: "green" }}></div>
          {t("dAvailableNow")}
        </div>
        <h1 className="text-white">
          {t("expertCare")}
        </h1>
        <h1 className="text-white">
          <em>{t("anywhere")}</em>
        </h1>
        <h1 className="text-white">
          {t("uAre")}
        </h1>
        <p className="text-white" style={{ maxWidth: "300px" }}>
          {t("instantConsultation")}
        </p>
        <div className="d-flex gap-3 mt-3 align-items-center">
          <div className="p-1 px-2 mb-4 d-flex align-items-center gap-2 rounded-pill text-white" style={{ border: "1px solid #FFFFFF", backgroundColor: "rgb(255, 255, 255,0.2)", fontSize: "13px", width: "fit-content" }}>
            <MdAccessTime size={14} className="mb-1" />
            {t("availableText")}
          </div>
          <div className="p-1 px-2 mb-4 d-flex align-items-center gap-2 rounded-pill text-white" style={{ border: "1px solid #FFFFFF", backgroundColor: "rgb(255, 255, 255,0.2)", fontSize: "13px", width: "fit-content" }}>
            <IoIosCheckmarkCircleOutline size={14} className="mb-1" />
            {t("boardCertified")}
          </div>
          <div className="p-1 px-2 mb-4 d-flex align-items-center gap-2 rounded-pill text-white" style={{ border: "1px solid #FFFFFF", backgroundColor: "rgb(255, 255, 255,0.2)", fontSize: "13px", width: "fit-content" }}>
            <FiLock size={14} className="mb-1" />
            {t("secureAndPrivate")}
          </div>
        </div>
      </div>

      <div className="w_full position-relative p-2 d-flex flex-column align-items-center justify-content-center overflow-y-auto" style={{ height: "100vh", backgroundColor: "#BB0700" }}>
        <Card className="p-0 mb-1 bg-white rounded-5 h-100">
          <div
            style={{
              backgroundImage: 'url("/assets/NewMiniapp/doctorBG.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              height: '240px',
            }}
            className="position-relative noDisplayOnWeb displayOnPhone rounded-5"
          >
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: `
    linear-gradient(
      to top,
      rgba(160, 14, 38, 1) 0%,
      rgba(160, 14, 38, 0.4) 100%
    )
  `,
              }}
            >
            </div>
            <div className="d-flex flex-column justify-content-end h-100 position-relative p-3" style={{ zIndex: "1" }}>
              <div className="d-flex gap-2 align-items-center">
                <div className="bg-white p-1">
                  <img src="/assets/NewMiniapp/logo-3.png" className="img-fluid" style={{ width: '55px' }} />
                </div>
                <div className="border border-white h-75"></div>
                <div className="text-start">
                  <p className="mb-0 text-white">
                    {t("e&")}
                  </p>
                  <p className="mb-0 text-white">
                    {t("poweredBy")}
                  </p>
                </div>
              </div>
              <h6 className="text-white text-start mt-2 mb-0">
                {t("expertCare")},
              </h6>
              <div className="d-flex">
                <h6 className="text-white mb-0 me-1">
                  <em>{t("anywhere")}</em>
                </h6>
                <h6 className="text-white mb-0">
                  {t("uAre")}
                </h6>
              </div>
            </div>
          </div>

          <div className="p-3 px-4 bg-white">
            <div className="noDisplayOnPhone">
              <div className="d-flex flex-column align-items-center">
                <img src="/assets/NewMiniapp/logo-3.png" className="img-fluid" style={{ width: '55px' }} />
                <span style={{ fontSize: "14px", color: "#333", marginTop: "10px" }}>
                  {t("digitalHealth")}
                </span>
              </div>
            </div>

            {/* <div className="mt-2"></div> */}

            <div className="d-flex justify-content-between my-4">
              <Header>{t("welcome")}</Header>
              <DropdownContainer>
                <DropdownHeader style={{ borderRadius: "100px", padding: "5px" }} onClick={() => setDropdownOpen(!dropdownOpen)}>
                  {/* <FontAwesomeIcon icon={faGlobe} /> */}
                  {/* <img src="assets/NewMiniapp/Globe.svg" className="me-2" style={{ width: "20px" }} /> */}
                  <LuGlobe className="my-auto mb-1" />
                  {t("selectedLanguage")}
                </DropdownHeader>
                {dropdownOpen && (
                  <DropdownMenu>
                    <DropdownItem onClick={() => handleLanguageChange("en")}>
                      English
                    </DropdownItem>
                    <DropdownItem onClick={() => handleLanguageChange("ps")}>
                      پشتو
                    </DropdownItem>
                    <DropdownItem onClick={() => handleLanguageChange("fa")}>
                      دری
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </DropdownContainer>
            </div>

            <form onSubmit={handleSubmit}>
              <FormField>
                <Label htmlFor="name" className="mb-0">{t("nameLabel")}</Label>
                <Input
                  type="text"
                  id="name"
                  placeholder={t("namePlaceholder")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={{ borderColor: errors.name ? "red" : "#ddd" }}
                  className="mb-2"
                />
                {errors.name && <ErrorText>{errors.name}</ErrorText>}
              </FormField>

              <FormField>
                <Label htmlFor="mobileNumber" className="mb-0 mt-2">{t("mobileNumberLabel")}</Label>
                <Input
                  type="text"
                  id="mobileNumber"
                  placeholder={t("mobileNumberPlaceholder")}
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  style={{ borderColor: errors.mobileNumber ? "red" : "#ddd" }}
                />
                {errors.mobileNumber && (
                  <ErrorText>{errors.mobileNumber}</ErrorText>
                )}
              </FormField>

              {/* <SubmitButton
            onClick={handleVerfification}
            type="submit"
            disabled={isVerifying}
          >
            {isVerifying ? t("verifyingText") : t("nextButton")}
          </SubmitButton> */}
              <SubmitButton
                type="submit" // Keep the type as "submit"
                disabled={isVerifying}
                style={{ backgroundColor: "#BB0700" }}
              >
                {isVerifying ? t("verifyingText") : t("nextButton")}
              </SubmitButton>
            </form>
            <div className="bg-white d-flex rounded-4 mt-4" style={{ border: "1px solid rgb(187, 7, 0, 0.5)" }}>
              <div className="p-2 w-50 text-center" style={{ borderRight: "1px solid rgb(187, 7, 0, 0.5)" }}>
                <h6 className="mb-0 fw-bold" style={{ color: "#E00800" }}>24/7</h6>
                <small className="mb-0 text-secondary">{t("support")}</small>
              </div>
              <div className="p-2 w-50 text-center">
                <h6 className="mb-0 fw-bold" style={{ color: "#E00800" }}> 4.9 <MdOutlineStarPurple500 /> </h6>
                <small className="mb-0 text-secondary">{t("rated")}</small>
              </div>
            </div>
            <div
              className="p-1"
              style={{
                backgroundColor: "rgb(224, 8, 0, 0.1)",
                borderRadius: "10px",
                fontSize: "12px",
                border: "1px solid #E00800",
                marginTop: "15px"
              }}
            >
              <p className="mb-0">
                <span className="fw-bold text-danger">
                  {t("disclaimerTitle")}
                  {":  "}
                </span>
                <span className="">{t("disclaimerText")}</span>
              </p>
            </div>
          </div>


        </Card>
      </div>

    </Container >
  );
};

export default SignUpForm;
